"use client";

import { useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/cn";
import type { Image as ImageType } from "@/lib/types";

type Props = {
  images: ImageType[];
  title: string;
};

export default function ProductGallery({ images, title }: Props) {
  const [active, setActive] = useState(0);
  const current = images[active] ?? images[0];

  return (
    <div className="flex flex-col gap-4">
      <div className="relative overflow-hidden rounded-[var(--radius-lg)] bg-[color:var(--color-surface-alt)] aspect-square">
        {current && (
          <Image
            src={current.url}
            alt={current.altText ?? title}
            fill
            sizes="(min-width: 1024px) 45vw, 100vw"
            className="object-cover"
            priority
          />
        )}
      </div>
      {images.length > 1 && (
        <ul className="grid grid-cols-4 sm:grid-cols-5 gap-3">
          {images.map((img, i) => (
            <li key={img.url}>
              <button
                type="button"
                onClick={() => setActive(i)}
                aria-label={`Show image ${i + 1}`}
                aria-pressed={i === active}
                className={cn(
                  "relative block aspect-square w-full overflow-hidden rounded-[var(--radius-sm)] border-2 bg-[color:var(--color-surface-alt)] transition-colors",
                  i === active
                    ? "border-[color:var(--color-primary)]"
                    : "border-transparent hover:border-[color:var(--color-border-strong)]",
                )}
              >
                <Image
                  src={img.url}
                  alt={img.altText ?? `${title} image ${i + 1}`}
                  fill
                  sizes="10rem"
                  className="object-cover"
                />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
